import { render, staticRenderFns } from "./NewComment.vue?vue&type=template&id=71b0a7cc"
import script from "./NewComment.vue?vue&type=script&lang=js"
export * from "./NewComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports